"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountsApplicationService = void 0;
const operators_1 = require("rxjs/operators");
class DiscountsApplicationService {
    constructor(repo) {
        this.repo = repo;
    }
    findDiscounts(tenantId) {
        return this.repo.getForTenant(tenantId);
    }
    async addDiscount(command) {
        const discounts = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (command.discount.name.trim() === '') {
            return {
                status: 'rejected',
                reason: 'Discount name is empty',
            };
        }
        if (!discounts.mayAddDiscount(command.discount)) {
            return {
                status: 'rejected',
                reason: `May not add the discount with name ${command.discount.name}`,
            };
        }
        await this.repo.put(discounts.withDiscountAdded(command.discount));
        return { status: 'accepted' };
    }
    async renameDiscount(command) {
        const discounts = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (command.newName.trim() === '') {
            return {
                status: 'rejected',
                reason: `New name is empty`,
            };
        }
        if (!discounts.discountWithNameExists(command.oldName)) {
            return {
                status: 'rejected',
                reason: `A discount with name ${command.oldName} does not exist`,
            };
        }
        if (discounts.discountWithNameExists(command.newName)) {
            return {
                status: 'rejected',
                reason: `A discount with name ${command.newName} already exists`,
            };
        }
        await this.repo.put(discounts.withDiscountRenamed(command.oldName, command.newName));
        return { status: 'accepted' };
    }
    async removeDiscount(command) {
        const discounts = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!discounts.discountWithNameExists(command.discountName)) {
            return {
                status: 'rejected',
                reason: `A discount with name ${command.discountName} does not exist`,
            };
        }
        await this.repo.put(discounts.withDiscountRemoved(command.discountName));
        return { status: 'accepted' };
    }
}
exports.DiscountsApplicationService = DiscountsApplicationService;
//# sourceMappingURL=discounts.application-service.js.map